var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"content-wrapper"},[_c('Loading',{attrs:{"is-loading":true}}),_c('h4',[_vm._v(_vm._s(_vm.$t('postgradStudentDocuments.certificate.modal.loading.title')))]),_c('p',[_vm._v(_vm._s(_vm.$t('postgradStudentDocuments.certificate.modal.loading.subtitle')))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }